import { profileVerified } from "assets";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";
import { useState } from "react";

import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  post: any;
  optionKey: string;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}
export default function NewFeedDailogBlock({ post, optionKey, isDialogOpen, setIsDialogOpen }: DialogProps) {
  const { showDialogConfirm } = appStore();
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false);
  const userPost = post.re_post_user ? post.re_post_user : post.user;

  const submitBlockUser = async (id: any) => {
    try {
      setloadingSubmit(true);

      let url = optionKey === "block_user" ? RouteApi.submitBlockUser : RouteApi.submitBoringUser;
      url += `token=${token}`;

      const data = {
        user_id: id,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setIsDialogOpen(false);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[submitBlockUser]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setloadingSubmit(false);
    }
  };

  return (
    <>
      <Dialog open={isDialogOpen}>
        <DialogContent
          onWheel={(e) => {
            e.stopPropagation();
          }}
          isShowBtnXClose={false}
          className="max-w-full lg:max-w-[800px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 "
        >
          <DialogHeader>
            <DialogTitle className=" text-start flex justify-center items-center">{optionKey === "block_user" ? "Block User" : "Boring User"}</DialogTitle>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => setIsDialogOpen(false)}
            >
              <X />
            </div>
          </DialogHeader>
          <ScrollArea className="mt-2 gap-3  pr-[20px] pb-[50px]">
            <div className="flex flex-row justify-between items-center space-x-2 ">
              <ImageUrlProfile user={userPost} className="w-[50px] h-[50px] rounded-full object-cover border shadow-md" isLinkProfile={true} />

              <div className="hidden xl:flex flex-row justify-between items-center w-full">
                <div className="flex flex-col">
                  <div className="flex items-center space-x-2">
                    <p className="text-sm font-medium">{userPost?.name}</p>
                    {userPost?.is_verified === "Yes" && <img src={profileVerified} alt="" style={{ width: 15, height: 15 }} />}
                  </div>
                  <div className="flex items-center space-x-2">
                    <p className="text-xs">
                      {`${userPost.no_of_follower ? `${userPost?.no_of_follower} Followers` : ""}
                                    ${userPost.no_of_like ? `• ${userPost?.no_of_like} Likes` : ""}
                                `}
                      {/* {[
                        post.re_post_user
                          ? post.re_post_user?.no_of_follower &&
                            `${post.re_post_user.no_of_follower} Followers`
                          : post.user?.no_of_follower &&
                            `${post.user.no_of_follower} Followers`,
                        post.re_post_user
                          ? post.re_post_user?.no_of_like &&
                            `${post.re_post_user.no_of_like} Likes`
                          : post.user?.no_of_like &&
                            `${post.user.no_of_like} Likes`,
                      ]
                        .filter(Boolean)
                        .join(" • ")} */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <br />
            {/* ===========Description Title=============== */}
            {optionKey === "block_user" ? (
              // ----------Description Block User-------------

              <p className="">
                At times, you might come across someone on the platform whose behavior makes you feel uncomfortable, unsafe, or simply annoyed. Whether it's unwanted messages,
                offensive content, or persistent interactions you’d rather not deal with, we believe you should always have control over your experience. That’s why we’ve made it
                easy for you to block another user. Blocking a user is a simple and powerful tool that immediately limits their ability to contact or interact with you. Once
                blocked, the person will no longer be able to: <br />
                <ul className="p-3">
                  <div className="flex gap-1 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2"> View your profile</li>
                  </div>
                  <div className="flex gap-2 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2">Send you messages</li>
                  </div>
                  <div className="flex gap-2 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2"> Comment on your posts</li>
                  </div>
                  <div className="flex gap-2 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2"> Like your content</li>
                  </div>
                  <div className="flex gap-2 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2">Mention or tag you in new posts </li>
                  </div>

                  <div className="flex gap-2 items-center justify-start">
                    <span className="bg-gray-900 dark:bg-gray-400 w-2 h-2 rounded-full"></span>
                    <li className="py-2">Follow you or see your updates in their feed</li>
                  </div>
                </ul>
                Note: Blocking is completely private. The person you block will not be notified.
              </p>
            ) : (
              // ----------Description Boring User-------------
              <p className="">
                Let’s be honest—sometimes, social media gets a little... meh. You start scrolling, and it’s just the same old updates, recycled memes, or endless humblebrags. Not
                offensive, not harmful—just not your vibe.
                <br />
                <br />
                That’s why we’ve created the Boring List.
                <br />
                <br />
                The Boring List is your personal tool to quietly filter out users whose content no longer excites, interests, or entertains you. You’re not unfollowing. You’re not
                blocking. You’re simply putting them in your digital “snooze drawer,” so your feed stays fresh and more aligned with your mood.
              </p>
            )}
            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Blcok",
                  titileButtonCancel: "No, Cancel",
                  title: "Block",
                  message: "Do you want to Block ?",

                  onSubmit() {
                    submitBlockUser(post.user_id);
                  },
                })
              }
              className="w-full mt-6   bg-red-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
            >
              {loadingSubmit ? <Loader className="animate-spin" /> : "Block"}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

